<template>
  <table class="base-table gap-4 w-full">
    <thead>
      <tr>
        <th v-for="col in tableColumns" :key="col.key" :class="[col.thClass, col.sortable ? 'sortable' : null]"
          @click="col.sortable && columnToggleSort(col.key)" :style="col.thStyle || null">
          {{ $t(col.label) | capitalize }}
          <span v-if="col.sortable" class="sort-icon">
            <span v-if="currentSortKey === col.key && currentSortOrder === 'asc'">
              <span class="material-icons sort-icon">keyboard_arrow_up</span>
            </span>
            <span v-else-if="currentSortKey === col.key && currentSortOrder === 'desc'">
              <span class="material-icons sort-icon">keyboard_arrow_down</span>
            </span>
            <span v-else>
              <span class="material-icons sort-icon">unfold_more</span>
            </span>
          </span>
        </th>
        <th v-if="actionButtons && actionButtons.length" style="width: 10vw;">
          {{ $t('actions') | capitalize }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, index) in tableData" :key="'tr-' + index">
        <td v-for="col in tableColumns" :key="col.key" :class="col.tdClass || null" :style="col.tdStyle || null">
          <slot :name="`col-${col.key}`" :row="row">
            {{ row[col.key] }}
          </slot>
        </td>
        <td v-if="actionButtons && actionButtons.length" class="buttons-row">
          <!-- <vs-button v-for="(button, btnIndex) in actionButtons" :key="'action-' + btnIndex"
            @click="() => { if (typeof button.onClick === 'function') button.onClick(row) }"
            v-if="!(button.hideIf ? button.hideIf(row) : false) && canAccess(button.permissions)" :color="button.color"
            :type="button.type" :outline="button.outline" :icon="button.icon">
            {{ $t(button.text) | capitalize }}
          </vs-button> -->
          <vx-tooltip 
            v-for="(action, btnIndex) in actionButtons"
            :key="'action-' + btnIndex"
            v-if="!(action.hideIf ? action.hideIf(row) : false) && canAccess(action.permissions)"
            :text="$t(action.text) | capitalize">
              <feather-icon 
                :icon="action.icon"
                svgClasses="h-5 w-5 cursor-pointer"
                :style="{ color: VARIANT_COLORS[action.color] || VARIANT_COLORS.primary }"
                @click="() => { if (typeof action.onClick === 'function') action.onClick(row) }"
              />
          </vx-tooltip>
        </td>
      </tr>
      <tr v-if="tableData.length" v-observe-visibility="onVisibilityChanged" style="visibility:hidden"></tr>
    </tbody>
  </table>
</template>

<script setup>
import { ref } from 'vue'
import { canAccess } from '@/utils/helpers'
import { capitalize } from '../../../utils/helpers'

const props = defineProps({
  tableColumns: { type: Array, required: true },
  tableData: { type: Array, required: true },
  actionButtons: { type: Array },
})

const emit = defineEmits(['sortChanged', 'loadMore'])

const currentSortKey = ref(null)
const currentSortOrder = ref(null)

function columnToggleSort(key) {
  if (currentSortKey.value === key) {
    currentSortOrder.value = currentSortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    currentSortKey.value = key
    currentSortOrder.value = 'asc'
  }
  emit('sortChanged', { key: currentSortKey.value, order: currentSortOrder.value })
}

function onVisibilityChanged(isVisible) {
  if (isVisible) {
    emit('loadMore')
  }
}

const VARIANT_COLORS = {
  primary: '#195BFF',
  info: '#7367F0',
  success: '#28C76F',
  danger: '#BC1300',
  warning: '#ff9f43',
  black: '#000000',
}

</script>

<style scoped>
.base-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 1rem;
  font-weight: 400;
  background-color: #fff;
}

.base-table th,
.base-table td {
  padding: 12px 10px;
  word-wrap: break-word;
  font-size: 1rem;
  font-weight: 400;
}

.base-table th {
  border-bottom: 1px solid #eee;
}

.base-table thead th {
  position: sticky;
  top: 0;
  background-color: #fff;
  color: #BC1300;
  font-weight: 600;
  font-size: 1rem;
  z-index: 10;
  border-bottom: 1px solid #ddd;
}

.base-table tbody tr:hover {
  background-color: #F5F5F5;
}

.buttons-row {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  min-height: 50px;
  align-items: center;
}

.sortable {
  cursor: pointer;
  user-select: none;
}

.sort-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
}

.sort-icon .material-icons {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 1;
  color: #BC1300;
}


</style>